import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

export class SidebarItemDTO {
  title: string;
  iconHostedLocally: boolean;
  iconIdentifier: string;
  isActive: () => any;
  displayIf: boolean;
  clickAction: () => any;
}

@Component({
  selector: 'app-sidebar-item',
  templateUrl: './sidebar-item.component.html',
  styleUrls: ['./sidebar-item.component.scss'],
})
export class SidebarItemComponent {
  @Input() itemTitle: string;
  @Input() iconHostedLocally: boolean;
  @Input() iconIdentifier: string;
  @Input() isActive: () => any;
  @Input() displayIf: boolean;
  @Input() clickAction: () => any;

  active: boolean = false;
  activeName: string;
  inactiveName: string;

  private routerEventSubscription: Subscription;

  public constructor(private router: Router) {
    this.routerEventSubscription = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.active = this.isActive();
      }
    });
  }

  ngOnDestroy() {
    this.routerEventSubscription.unsubscribe();
  }

  handleClick = () => {
    this.clickAction();
  };

  getIconSrcName(inactiveName: string, isSelected: boolean): string {
    let suffix = `${isSelected ? '_Active' : ''}.svg`;
    return inactiveName + suffix;
  }
}
